import { Company, CompanyAddress } from "./company.types"

// CompanyAddressZone interface (assuming it has id and name)
export interface CompanyAddressZone {
  id: string
  name: string
}

export enum DataVisualizationRequestType {
  EVOLUTION_OVER_TIME_ANALYSIS = "EVOLUTION_OVER_TIME_ANALYSIS",
}

export enum InputParameterType {
  COMPANY = "COMPANY",
  COMPANY_ADDRESS = "COMPANY_ADDRESS",
  COMPANY_ADDRESS_ZONE = "COMPANY_ADDRESS_ZONE",
  PERIOD = "PERIOD",
  ZIPCODE = "ZIPCODE",
  SHIPPER = "SHIPPER",
  GRANULARITY = "GRANULARITY",
  GROUPING_TYPE = "GROUPING_TYPE",
}

export enum DataVisualizationGranularity {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum DataVisualizationGroupingType {
  PERIOD = "PERIOD",
  COMPANY = "COMPANY",
  ADDRESS = "ADDRESS",
  COMPANY_ADDRESS = "COMPANY_ADDRESS",
  COMPANY_ADDRESS_ZONE = "COMPANY_ADDRESS_ZONE",
  SHIPPER = "SHIPPER",
}

export enum DataVisualizationRelativePeriod {
  LAST_30_DAYS = "LAST_30_DAYS",
  ALL_TIME = "ALL_TIME",
}

export interface DataVisualizationPeriodInput {
  startDate?: Date
  endDate?: Date
  relative?: DataVisualizationRelativePeriod
}

export interface DataVisualizationFilters {
  addressId?: string
  companyId?: string
  companyAddressId?: string
  companyAddressZoneId?: string
  shipperName?: string
  clientIds?: string[]
  verified?: boolean
  disputed?: boolean
  completionStatuses?: ParcelCompletionStatus[]
  onlyCompleted?: boolean
}

export interface DataVisualizationRequest {
  type: DataVisualizationRequestType
  filters: DataVisualizationFilters
  period: DataVisualizationPeriodInput
  groupingType: DataVisualizationGroupingType
  granularity: DataVisualizationGranularity
}

export interface DataVisualizationRequestConfig {
  type: DataVisualizationRequestType
  label: string
  description: string
  icon: string
  mandatoryInputs: InputParameter[]
  optionalInputs: InputParameter[]
}

export interface InputParameter {
  type: InputParameterType
  required: boolean
  label: string
  placeholder?: string
  multiple?: boolean
  dependsOn?: InputParameterType[]
}

export interface DataVisualizationPeriodColumn {
  kind: DataVisualizationGranularity
  expression: string
  alias: string
}

// Initial data types
export interface DataVisualizationInitialData {
  companies: Pick<Company, "id" | "name">[]
  companyAddresses: Pick<CompanyAddress, "id" | "name" | "companyId" | "zoneId">[]
  companyAddressZones: Pick<CompanyAddressZone, "id" | "name">[]
}

// ParcelCompletionStatus enum (assuming it exists elsewhere, adding here for completeness)
export enum ParcelCompletionStatus {
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  RETURNED = "RETURNED",
}

// Legacy interface for backward compatibility
export interface FilterValues {
  company?: string
  companyAddress?: string
  companyAddressZone?: string
  period?: {
    startDate: Date
    endDate: Date
  }
  zipcodes?: string[]
  shipper?: string
}

export interface DataVisualizationState {
  selectedRequestType: DataVisualizationRequestType | null
  filterValues: FilterValues
  isLoading: boolean
  data: any[]
  error: string | null
}

export interface CompanyOption {
  value: string
  label: string
}

export interface CompanyAddressZoneOption {
  value: string
  label: string
  companyId: string
}

export interface CompanyAddressOption {
  value: string
  label: string
  companyId: string
}

export interface ZipcodeOption {
  value: string
  label: string
  companyId: string
}
